import { combineReducers } from "redux";

import languageList from "./languageList";
import fetching from "./fetching";

export default combineReducers({ languageList, fetching });
